import { Slot } from "@-/com.npmjs.expo-router";
import { FrostedBackdropTarget } from "@-/dev.improve.haniverse.components.ui.frosted-surface";
import { View } from "@-/com.npmjs.react-native";
import { CollectionsLayoutContextProvider } from "#collections-layout-context-provider";
import { PrimaryControlsStripBack } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import { CollectionsLayoutToolbar } from "#collections-layout-toolbar";

/**
 * Shared layout for the Collections list and detail routes. Collections keeps its own toolbar
 * actions independent of the Decks tab's Upcoming / Mastered state.
 */
export function CollectionsLayout() {
  return (
    <CollectionsLayoutContextProvider>
      <View className="flex-1 bg-background">
        {/* Hidden back at the SAME depth as the toolbar's More menu (the registry's override-wins tie),
            as Learn does. A page publishing it one level deeper outranked the menu, so the slot stayed
            empty on Android (staging run 36156144212: no "Show more actions"). */}
        <PrimaryControlsStripBack hidden />
        <CollectionsLayoutToolbar />
        <FrostedBackdropTarget className="flex-1">
          <Slot />
        </FrostedBackdropTarget>
      </View>
    </CollectionsLayoutContextProvider>
  );
}
